'use client';

import type { LoginButtonProps } from './login-button';
import React from 'react';
import dynamic from 'next/dynamic';
import LoginLink from './login-link';

// This currently is not working. Webpack throws a runtime error when trying to load the dynamic import.
// It has something to do with the use of Context and State in the ModalProvider, though the error appears
// to be raised by an attempt to import the React JSX runtime in that file.
const DynamicLoginButton = dynamic<LoginButtonProps>(
  () => import('@/components/ui/login-button/login-button'),
  {
    // ssr: false,
    loading: () => <LoginLink />,
  },
);

export default function LoginButton(props: LoginButtonProps = {}) {
  return <DynamicLoginButton {...props} />;
}
